const hostMap = {
  'fs-dashboard.marketxpander.net': 'https://fieldsales.marketxpander.net',
  'fs-dashboard.crm4b2c.com': 'https://fieldsales.crm4b2c.com',
  'fs-dashboard.lsq-staging.com': 'https://fieldsales.lsq-staging.com',
  'fs-dashboard-in22.leadsquared.com': 'https://fieldsales-in22.leadsquared.com'
};

const defaultHost = 'https://fieldsales-in21.leadsquared.com';

/**
 * The custom build is served from a NextGen custom domain under /fs, and its API calls go back to
 * that same origin. NextGen's appgateway fronts both: it matches /api/fs/** and rewrites the path
 * to /api/** before forwarding to the FieldSales gateway, so `/fs` is inserted after `/api`
 * rather than prefixed onto the whole path.
 *
 * The origin is read from the page rather than baked in, because one build serves every tenant
 * domain (ujjivan, and whatever comes next). REACT_APP_API_ORIGIN exists only so a local build
 * can point at a real environment; leaving it unset is what production does.
 *
 * PUBLIC_URL discriminates because only `npm run build:custom` sets it. If the two concerns ever
 * diverge — a subpath build that still calls the FieldSales gateway directly — this is the single
 * line to swap for a dedicated env var.
 */
const isCustomBuild = Boolean(process.env.PUBLIC_URL);

export const API_PREFIX = isCustomBuild ? '/fs' : '';

let baseURL = isCustomBuild
  ? process.env.REACT_APP_API_ORIGIN || window.location.origin
  : hostMap[window.location.host] || defaultHost;

export const CONFIG = {
  FS_SETTINGS:
    baseURL +
    `/api${API_PREFIX}` +
    (process.env.REACT_APP_FS_SETTINGS_BASE_URL || '/fieldsales-settings/v1')
};

export default baseURL;
